import styled from 'styled-components'
import { device } from './breakpoints'

const Strong = styled.strong`
  font-weight: bold;
  padding: 0.25em 0.65em;
  // margin-left: 0.25em;
  // margin-right: 0.25em;
  font-size: 0.75em;
  background-color: rgba(${({ theme }) => theme.colorMain});
  color: rgb(${({ theme }) => theme.colorMode === 'dark' ? theme.siteBackground : '255,255,255'});
  white-space: nowrap;
  font-family: var(--font-sans-serif);
  -webkit-font-smoothing: antialiased;
`

const Link = styled.a`
  color: rgb(${({ theme }) => theme.colorMain});
  cursor: pointer;
  text-decoration: none;
  padding: 0.2rem 0 0;
  background-image: linear-gradient(
    to right,
    rgb(${({ theme }) => theme.colorMain}) 0,
    rgb(${({ theme }) => theme.colorMain}) 10%
  );
  background-size: 100% 1px;
  background-position-y: 17px;
  background-repeat: repeat-x;
  background-position: bottom;
  white-space: nowrap;
`

const Source = styled.div`
  font-size: 0.65em;
  color: rgb(${({ theme }) => theme.textColor});
  line-height: 1.2;
  margin-top: 10px;
  opacity: 0.5;
`

const Notes = styled.div`
  font-size: 0.75em;
  line-height: 1.2;
  margin-bottom: 3px;
`

const Button = styled.div`
  font-size: 0.75em;
  line-height: 1.2;
  background-color: rgb(${({ theme }) => theme.colorMain});
  color: rgb(${({ theme }) => theme.colorMode === 'dark' ? theme.textColorInverted : '255,255,255'});
  padding: 0.65em 1.2em 0.65em 1em;
  display: inline-flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`

const ChartTitle = styled.div`
  font-weight: bold;
  line-height: 1.4;
  margin-bottom: 0.2em;
`
const ChartDescription = styled.div`
  font-size: 0.85em;
  max-width: 600px;
  line-height: 1.4;
  margin-bottom: 20px;
  // color: rgb(${({ theme }) => theme.grayColorDark});
`

const Label = styled.div`
  position: absolute;
  font-size: 0.85em;
  line-height: 1.2;
  width: 200px;
  color: rgb(${({ theme }) => theme.textColor});
  text-shadow: ${({ theme }) =>
    `-1px -1px 0 rgb(${theme.siteBackground}), 0 -1px 0 rgb(${theme.siteBackground}), 1px -1px 0 rgb(${theme.siteBackground}), 1px 0 0 rgb(${theme.siteBackground}), 1px 1px 0 rgb(${theme.siteBackground}), 0 1px 0 rgb(${theme.siteBackground}), -1px 1px 0 rgb(${theme.siteBackground}), -1px 0 0 rgb(${theme.siteBackground})`};
`

export {
  Strong,
  Link,
  Source,
  ChartTitle,
  ChartDescription,
  Notes,
  Button,
  Label,
}
